(ns ui.editors.simple-filters.components.selection-row
  (:require
   [reagent.core :as r]
   [ui.components.input.checkbox :as checkbox]
   [ui.components.radix-ui.tooltip.view :as tooltip]
   [ui.dom-globals :as dg]))

(defn- call-handler
  [handler event]
  (when (fn? handler)
    (handler event)))

(defn view
  [{:keys [selected? label on-click id control-type]
    :or {control-type :checkbox}}]
  (r/with-let [show-tooltip?* (r/atom false)]
    (let [radio? (= control-type :radio)
          label-text (str (or label ""))]
    [:div
     {:class "tw2-flex tw2-flex-col tw2-min-w-0"}
     [:label
      {:for (or id "")
       :class "tw2-flex tw2-items-center tw2-gap-checkbox-gap tw2-cursor-pointer tw2-min-w-0"}
      [checkbox/view
       {:id id
        :value selected?
        :style-variant :tw2
        :wrapper-class (when radio?
                         "tw2-rounded-full")
        :checked-icon (when radio?
                        [:span
                         {:class "tw2-w-2 tw2-h-2 tw2-rounded-full tw2-bg-white"}])
        :on-change (fn [_next]
                     (when (fn? on-click)
                       (on-click nil)))}]
      [tooltip/as-child
       {:side :top
        :align :start
        :disabled? (not @show-tooltip?*)}
       (fn [{:keys [ref class] :as trigger-props}]
         (let [base-mouse-enter (or (:on-mouse-enter trigger-props)
                                    (:onMouseEnter trigger-props))
               base-focus (or (:on-focus trigger-props)
                              (:onFocus trigger-props))
               update-overflow! (fn [e]
                                  (let [el (dg/target e)]
                                    (reset! show-tooltip?*
                                            (> (or (dg/scroll-width el) 0)
                                               (or (dg/client-width el) 0)))))]
           [:span
            (-> trigger-props
                (dissoc :on-mouse-enter :onMouseEnter :on-focus :onFocus)
                (assoc :ref ref
                       :on-mouse-enter (fn [e]
                                         (call-handler base-mouse-enter e)
                                         (update-overflow! e))
                       :on-focus (fn [e]
                                   (call-handler base-focus e)
                                   (update-overflow! e))
                       :class (str (or class "")
                                   " tw2-flex-1 tw2-min-w-0 tw2-overflow-hidden tw2-text-ellipsis tw2-whitespace-nowrap tw2-text-sm tw2-font-normal tw2-leading-2 tw2-text-primary")))
            label-text]))
       label-text]]])))
